import { ApiError } from './api-client';

/**
 * Turns an unknown error into something showable.
 *
 * In `lib/` rather than beside `ErrorState`, for two reasons. It is a pure function with no JSX, so a
 * component file is the wrong home — and exporting a non-component from a component file breaks Vite's
 * fast refresh for that whole module, which ESLint flags.
 *
 * Shared rather than duplicated because every form reporting a failed mutation needs the same
 * plain-language message and correlation id, and a second copy would drift from what `ErrorState`
 * shows for the very same error.
 */
export function describeError(error: unknown): {
  message: string;
  correlationId: string | null;
  isForbidden: boolean;
} {
  if (error instanceof ApiError) {
    return {
      message: error.message,
      correlationId: error.correlationId === 'unknown' ? null : error.correlationId,
      isForbidden: error.isForbidden,
    };
  }

  if (error instanceof Error) {
    // A network failure or a bug in our own code. The message is ours, not a server's, so it is
    // safe to show — but it gets no correlation id, because there is no server log to match.
    return { message: error.message, correlationId: null, isForbidden: false };
  }

  return { message: 'An unexpected error occurred.', correlationId: null, isForbidden: false };
}
